import type { StatusChipProps } from '@app/src/components/StatusChip'
import StatusChip from '@app/src/components/StatusChip'
import React from 'react'
import { CellStatus } from './accessMatrix'

const statusColor: Record<CellStatus, StatusChipProps['color']> = {
  [CellStatus.Included]: 'success',
  [CellStatus.Granted]: 'info',
  [CellStatus.Locked]: 'warning',
  [CellStatus.Denied]: 'error',
  [CellStatus.Hidden]: 'default',
  [CellStatus.NotApplicable]: 'default',
}

const EntitlementStatusChip: React.FC<{ status: CellStatus }> = ({ status }) => (
  <StatusChip color={statusColor[status]} label={status} />
)

export default EntitlementStatusChip
